import { Input_Base } from './Input_Base.ts';
import { RadioGroup } from '@services/MarppleShop/renderApp/components/cells/RadioGroup/RadioGroup.ts';
import { InputEditor } from '@services/MarppleShopStudio/widget/CreatorProduct/ui/ProductForm/input-views/type.ts';
import klass from './Input.module.scss';
import { font } from '@services/MarppleShop/shared/typography';
import { ValidateField } from '@services/MarppleShopStudio/widget/CreatorProduct/core/zod-schema/shared.ts';

interface item {
  id: string;
  display_name: string;
  value?: unknown;
}

interface InputRadioGroupData extends Omit<InputEditor, 'value'> {
  is_public: boolean;
  items: Array<item>;
}

export class Input_RadioGroup extends Input_Base<InputRadioGroupData> {
  radioGroupView = new RadioGroup(
    {
      items: this.data.items,
      selected_id: String(this.data.is_public),
    },
    {
      custom_klass: {
        group: klass.radio_group,
        item: font('14_medium'),
      },
    },
  );

  protected inputTemplate() {
    return this.radioGroupView;
  }

  public get changeEvent() {
    return this.radioGroupView.changeEvent;
  }

  public getName(): ValidateField {
    return this.data.name;
  }

  public override setError() {
    return void 0;
  }

  public getValue(): boolean {
    return !!this.radioGroupView.getSelected()?.value;
  }
}
